import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/shared";

export default function AdminSettings() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div data-testid="admin-settings">
      <PageHeader title={t("adm.setTitle")} />
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <div className="mb-4 flex items-center gap-2 font-heading font-bold text-navy"><ShieldCheck className="h-4 w-4 text-cyan-dark" /> {t("adm.setAccount")}</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between border-b border-slate-50 py-2"><span className="text-slate-400">{t("adm.usName")}</span><span className="font-medium text-navy">{user?.first_name} {user?.last_name}</span></div>
            <div className="flex justify-between border-b border-slate-50 py-2"><span className="text-slate-400">{t("adm.usEmail")}</span><span className="font-medium text-navy">{user?.email}</span></div>
            <div className="flex justify-between py-2"><span className="text-slate-400">{t("adm.usRole")}</span><span className="font-medium text-navy">{user?.role?.replace("_", " ")}</span></div>
          </div>
          <p className="mt-4 text-xs text-slate-400">{t("adm.setNote")}</p>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <div className="mb-4 font-heading font-bold text-navy">{t("adm.setSession")}</div>
          <Button variant="outline" className="rounded-full text-red-600" onClick={async () => { await logout(); nav("/login"); }} data-testid="admin-settings-logout"><LogOut className="mr-2 h-4 w-4" /> {t("aNav.logout")}</Button>
        </div>
      </div>
    </div>
  );
}
